export default __webpack_public_path__ + "static/media/ap logo small.0a6ea964.png";